import { Button, Modal, Form, Row, Col, Input, Checkbox } from "antd";
import { useCreateSiteMutation } from "../../../../store/endpoints/trace/site";

export default function CreateSite({ isVisible, hideModal }: any) {
  const [createSite, { isLoading }] = useCreateSiteMutation();

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.validateFields();
    await createSite(values);
    hideModal();
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      visible={isVisible}
      title="New Site"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createSite"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createSite"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter site name",
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item name="isDealer" valuePropName="checked" noStyle>
              <Checkbox defaultChecked={false}>3rd Part Dealer</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item name="isAutoInc" valuePropName="checked" noStyle>
              <Checkbox defaultChecked={false}>Auto Inc - Location</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
